import { User } from '../types';

export const toUserDTO = (user: any): User => ({
  ...user,
  id: user.user_id,
  name: `${user.firstname} ${user.lastname}`,
  isPublished: user.published?.some((value: string) => value !== 'null')
});

export const fromUserDTO = (user: any) => ({
  firstname: user.firstname,
  lastname: user.lastname,
  email: user.email,
  phone_number: user.phone_number,
  profile_pic: user.avatarSrc,
  new_password: user.newPassword,
});